import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Commission.css';

const Commission = () => {
  const [commissionPercentage, setCommissionPercentage] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchCommission();
  }, []);

  const fetchCommission = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.get('/commissions/settings');
      if (response.data && response.data.data && response.data.data.general_commission_percentage !== undefined) {
        setCommissionPercentage(response.data.data.general_commission_percentage.toString());
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      console.error('Error fetching commission:', err);
      setError('Failed to load commission settings. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    
    // Validate input
    const commissionValue = parseFloat(commissionPercentage);
    if (isNaN(commissionValue) || commissionValue < 0 || commissionValue > 100) {
      setError('Commission percentage must be a number between 0 and 100.');
      setSaving(false);
      return;
    }

    try {
      const response = await api.put('/commissions/settings', {
        general_commission_percentage: commissionValue
      });
      
      if (response.data && response.data.success) {
        setSuccess('Commission percentage updated successfully!');
        // Update the local state with the saved value
        setCommissionPercentage(commissionValue.toString());
      } else {
        throw new Error(response.data?.message || 'Failed to update commission');
      }
    } catch (err) {
      console.error('Error updating commission:', err);
      setError(err.response?.data?.message || err.message || 'Failed to update commission settings. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="commission-page">
      <div className="page-header">
        <h1>Commission Settings</h1>
        <p className="page-description">
          Manage the general commission percentage applied to all bookings
        </p>
      </div>

      {error && (
        <div className="alert alert-error">
          {error}
        </div>
      )}

      {success && (
        <div className="alert alert-success">
          {success}
        </div>
      )}

      <div className="commission-form-container">
        <form onSubmit={handleSubmit} className="commission-form">
          <div className="form-group">
            <label htmlFor="commissionPercentage">
              General Commission Percentage (%)
            </label>
            <div className="input-with-addon">
              <input
                type="number"
                id="commissionPercentage"
                value={commissionPercentage}
                onChange={(e) => setCommissionPercentage(e.target.value)}
                min="0"
                max="100"
                step="0.01"
                placeholder="Enter commission percentage"
                disabled={loading || saving}
                className="form-control"
              />
              <span className="addon">%</span>
            </div>
            <p className="help-text">
              Enter the commission percentage that will be applied to all bookings (0-100%)
            </p>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={fetchCommission}
              disabled={loading || saving}
              className="btn btn-secondary"
            >
              {loading ? 'Loading...' : 'Refresh'}
            </button>
            <button
              type="submit"
              disabled={loading || saving}
              className="btn btn-primary"
            >
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Commission;